export enum ContractDetailsRequestedPromptOptions {
  // MARKER 2022/07/08 Not an exhaustive list
  DROPDOWN = 'dropdown',
  LIST = 'list',
  RADIO = 'radio',
  SIMPLE = 'simple',
  SELECT = 'select',
  VALUEPROP = 'valueprop'
}

export enum InterstitialTypes {
  MODAL = 'modal',
  SLIDEOUT = 'slideOut',
}

